import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./login.css";
import { checkPhoneNumber, sendOTPfunction } from "../../api/login_api";
import Swal from "sweetalert2";

const Login = () => {
  const navigate = useNavigate();
  const [countryCode, setCountryCode] = useState("+91");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [error, setError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleCountryCodeChange = (e) => {
    setCountryCode(e.target.value);
  };

  const handleSignIn = async (e) => {
    e.preventDefault();

    // Validate phone number length
    if (phoneNumber.length !== 10) {
      setError(true);
      return;
    }

    setIsLoading(true);

    try {
      // Check if phone number exists in database
      const response = await checkPhoneNumber(phoneNumber);

      if (!response) {
        Swal.fire({
          title: "Oops!",
          text: "No staff found with this phone number",
          icon: "error",
          width: "400px",
        });
        setPhoneNumber("");
        setIsLoading(false);
        return;
      }

      // Send OTP
      const res = await sendOTPfunction(phoneNumber);

      if (res.success) {
        // OTP sent successfully
        Swal.fire({
          title: "OTP Sent Successfully!",
          text: `Verification code sent to ${res.phoneNumber}`,
          icon: "success",
          width: "400px",
          timer: 2000,
          showConfirmButton: false,
        });

        // Navigate to OTP page with necessary data
        navigate("/otp", {
          state: {
            Otp: res.otp,
            phoneNumber: res.phoneNumber,
            otpSent: true,
          },
        });
      } else {
        // Failed to send OTP
        Swal.fire({
          title: "Error Occured",
          text: res.error || "Unable to send OTP. Please try again.",
          icon: "error",
          width: "400px",
        });
      }
    } catch (error) {
      console.error("Error during sign in:", error);
      Swal.fire({
        title: "Error!",
        text: "An unexpected error occurred. Please try again.",
        icon: "error",
        width: "400px",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const onChangeNumberFunction = (e) => {
    // Remove non-digit characters
    let value = e.target.value.replace(/\D/g, "");

    // Limit to 10 digits
    if (value.length > 10) {
      value = value.slice(0, 10);
    }
    setPhoneNumber(value);
    setError(false);
  };

  const handleGoogleSignIn = () => console.log("Google Sign In clicked");
  const handleAppleSignIn = () => console.log("Apple Sign In clicked");
  const handleCreateAccount = () => {
    navigate("/create-account");
  };

  localStorage.clear("authUser");

  return (
    <div className="wc-login-container">
      {/* Left Section - Branding */}
      <div className="wc-login-left-section">
        <div className="wc-login-decorative-shape shape-1"></div>
        <div className="wc-login-decorative-shape shape-2"></div>

        <div className="wc-login-content">
          <div className="wc-login-logo-wrapper">
            <div className="wc-login-logo-glass-card">
              <img
                src="/wealth-compounders.png"
                alt="Wealth Compounders"
                className="wc-login-logo-img"
              />
            </div>
          </div>

          <h1 className="wc-login-title">Welcome Back</h1>
          <p className="wc-login-subtitle">
            Sign in to access your account and continue
            <br />
            your journey with us.
          </p>

          <div className="wc-login-oauth-buttons">
            <button
              className="wc-login-oauth-btn wc-login-google-btn"
              onClick={handleGoogleSignIn}
            >
              <svg viewBox="0 0 24 24" className="wc-login-oauth-icon">
                <path
                  fill="#fff"
                  d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                />
                <path
                  fill="#fff"
                  d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                />
                <path
                  fill="#fff"
                  d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                />
                <path
                  fill="#fff"
                  d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                />
              </svg>
              Google
            </button>

            <button
              className="wc-login-oauth-btn wc-login-apple-btn"
              onClick={handleAppleSignIn}
            >
              <svg
                viewBox="0 0 24 24"
                className="wc-login-oauth-icon"
                fill="currentColor"
              >
                <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
              </svg>
              Apple
            </button>
          </div>

          <div className="wc-login-footer-text">
            <span>Don't have an account? </span>
            <button onClick={handleCreateAccount}>Create Account</button>
          </div>
        </div>
      </div>

      {/* Right Section - Form */}
      <div className="wc-login-right-section">
        <div className="wc-login-form-container">
          <div className="wc-mobile-logo-placeholder">
            {/* Logo shown only on mobile */}
            <img src="/wealth-compounders.png" alt="Logo" />
          </div>

          <h2 className="wc-login-form-title">Sign In</h2>
          <p className="wc-login-form-subtitle">
            Enter your credentials to access your account.
          </p>

          <form onSubmit={handleSignIn}>
            <div className="wc-login-form-group">
              <label className="wc-login-label">Phone Number</label>
              <div className="wc-login-input-wrapper">
                <div className="wc-login-phone-input-container">
                  <select
                    className="wc-login-country-code"
                    value={countryCode}
                    onChange={handleCountryCodeChange}
                  >
                    <option value="+91">+91</option>
                    <option value="+1">+1</option>
                    <option value="+44">+44</option>
                    <option value="+971">+971</option>
                  </select>
                  <input
                    type="tel"
                    className="wc-login-phone-input"
                    placeholder="Enter Phone Number"
                    value={phoneNumber}
                    onChange={onChangeNumberFunction}
                    maxLength="10"
                    required
                    disabled={isLoading}
                  />
                  <div className="wc-input-status-icon">
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            {error && (
              <p className="wc-login-card-error">
                Phone number must be 10 digits
              </p>
            )}
            <button
              type="submit"
              className="wc-otp-submit-btn"
              disabled={isLoading}
            >
              {isLoading ? "Sending..." : "Get OTP"}
              {!isLoading && (
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5 12H19M19 12L12 5M19 12L12 19"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              )}
            </button>

            <p className="wc-login-terms">
              By signing in, you agree to our <a href="/terms">Terms</a> and{" "}
              <a href="/privacy">Privacy Policy</a>
            </p>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
